export const BROKERS_PAGE_MAX_WIDTH = 1120;
export const BROKER_FORM_LINK = '/brokers#broker-form';
export const BROKER_FORM_LINK_SCROLL_OFFSET = -128;
